import {
  type BuilderConfig as BuilderConfigFromTypes,
  CARD_TYPES,
  type CardType as CardTypeFromTypes,
  builderConfigSchema as builderConfigSchemaFromTypes,
} from '@zeus-health/types';

// Feel free to temporarily override these deprecated values using schema shapes from @zeus-health/types,
// but always try to keep the shared package up to date.

/** @deprecated use CARD_TYPES in @zeus-health/types */
export const cardTypes = CARD_TYPES;

/** @deprecated use CardType in @zeus-health/types */
export type CardType = CardTypeFromTypes;

/** @deprecated use builderConfigSchema in @zeus-health/types */
export const builderConfigSchema = builderConfigSchemaFromTypes;

/** @deprecated use BuilderConfig in @zeus-health/types */
export type BuilderConfig = BuilderConfigFromTypes;

export function getDefaultBuilderConfig(builderId: string): BuilderConfigFromTypes {
  return {
    builderId,
    showRequestRecords: true,
    patientOverviewPage: {
      cards: [
        { type: 'conditions' },
        { type: 'referrals' },
        { type: 'medications' },
        { type: 'diagnostics' },
        { type: 'episodesOfCare' },
        { type: 'vitals' },
        { type: 'zusInformation' },
        { type: 'careGaps' },
        { type: 'risk-gaps' },
      ],
    },
    riskGaps: {
      lensEnabled: false,
      showConfidenceLevels: true,
      lensIncludeAllPatients: false,
      statusOptions: {},
    },
  };
}
